import Breadcrumb from "Components/UI/Breadcrumb";
import Spinners from "Components/UI/Spinner";
import PaginatedTable from "Components/Tables/PaginatedTable";
import React, { useEffect, useState } from "react";
import { Card, CardBody, Container } from "reactstrap";
import useTableFilters from "helpers/hooks/useTableFilters";
import { deleteProductPermanently, getProducts, restoreProduct } from "helpers/API Calls/Operations/Products";
import { generateQueryParams } from "helpers/queryParams";
import convertDateFormat from "Components/Date/DateFormat";
import ConformationModal from "Components/Modals/ConformationModal";
import DeleteModal from "Components/Modals/DeleteModal";
const head = [
  {id: 1, name: "#", isSortable: true, key: "id"},
  {id: 2, name: "Product", isSortable: true, key: "product_name"},
  {id: 21, name: "Type", isSortable: true, key: "product_type_id"},
  {id: 3, name: "Price", isSortable: true, key: "price"},
  {id: 4, name: "Category", isSortable: true, key: "main_category_id"},
  {id: 21, name: "Status", isSortable: false, key: "status"},
  {id: 5, name: "Created", isSortable: true, key: "created_at"},
  {id: 6,name: "Updated", isSortable: true, key: "updated_at"},
  {id: 7,name: "Actions"}
]

function Products() {

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [products, setProducts] = useState<any[]>([]);
  const [pagination, setPagination] = useState<any>({current_page: 1, last_page: 1, per_page: 10, total: 0});

  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [restoreModal, setRestoreModal] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  
  const { filters, updateFilter } = useTableFilters();

  const fetchData = async () => {
    setIsLoading(true);
    const response = await getProducts(generateQueryParams(filters)+`&deleted=1`);
    if (response.success) {
      setProducts(response.data.items);
      setPagination(response.data.pagination);
    }
    setIsLoading(false);
  }

  useEffect(() => {
    fetchData();
  }, [filters]);

  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    if (selectedItem) {
      const response = await deleteProductPermanently(selectedItem.id);
      if (response.success) {
        setDeleteModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onCloseClick = () => {
    setDeleteModal(false);
    setSelectedItem(null);
  };
  
    const handleRestoreClick = (item) => {
    setSelectedItem(item);
    setRestoreModal(true);
  };

  const handleRestoreConfirm = async () => {
    if (selectedItem) {
      const response = await restoreProduct(selectedItem.id);
      if (response.success) {
        setRestoreModal(false);
        setSelectedItem(null);
        fetchData();
      }
    }
  };

  const onClose = () => {
    setRestoreModal(false);
    setSelectedItem(null);
  };

  return (
    <>
    <div className="page-content">
      <Container fluid >
        <Breadcrumb items={[{ label: "Deleted Products", link: "/products/deleted" }]} />
        {isLoading ? <div className="position-relative vh-100"><Spinners/></div>
        :
        <Card>
          <CardBody>
            <PaginatedTable
              tableHead={head}
              pagination={pagination}
              updateFilter={updateFilter}
              filters={filters}
            > 
              {products.length > 0 && products.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.product_name}</td>
                    <td>{item?.product_type?.product_type_name}</td>
                    <td>{item?.product_price?.price}</td>
                    <td>{item?.main_category?.category_name}</td>
                    <td>
                      <span className={`badge badge-soft-danger`}>
                        Deleted
                      </span>
                    </td>
                    <td>{convertDateFormat(item.created_at)}</td>
                    <td>{convertDateFormat(item.updated_at)}</td>
                    <td>
                    <div>
                      <button className="btn btn-warning btn-sm me-1" onClick={() => handleRestoreClick(item)}><i className="mdi mdi-refresh"></i></button>
                      <button className="btn btn-danger btn-sm" onClick={() => handleDeleteClick(item)}><i className="mdi mdi-trash-can-outline"></i></button>
                    </div>
                  </td>
                  </tr>))
                }
                {!isLoading && products.length === 0 && <tr className="text-center"><td colSpan={head.length} className="text-danger">No Data Found</td></tr>}
                
            </PaginatedTable>
          </CardBody>
        </Card>}
      </Container>
    </div>
    {deleteModal && 
    <DeleteModal
      show={deleteModal}
      onDeleteClick={handleDeleteConfirm}
      onCloseClick={onCloseClick}
      message={`"${selectedItem?.product_name}" permanently`}
    />}
    {restoreModal &&
    <ConformationModal
      show={restoreModal}
      onConfirmClick={handleRestoreConfirm}
      onCloseClick={onClose}
      buttonText="Restore"
      textBefore = "restore"
      message={`"${selectedItem?.product_name}"`}
      textAfter='product'
    />}
    </>
  );
}

export default Products;
